import style from "./semilleros.module.css";
//import Semilla from "../../components/Semilla";
import Helmets from "../../widgets/Helmet";
import WhatsappButton from "../../components/whatsappbutton";
import foto from "../../assets/voto.png";

const Semilleros: React.FC = () => {
  return (
    <>
      <Helmets />
      <main className={style.Semilleros}>
        <WhatsappButton />
        {/* <Semilla /> */}
        <img
          //className={style.FotoImgMedios}
          src={foto}
          alt="voto"
          draggable={false}
        />
      </main>
    </>
  );
};

export default Semilleros;
